import axios from 'axios'
import { Message } from 'element-ui'
// import router from '@/router'
// import { logout } from '@/api/user'

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // 是否携带cookie, 允许后台设置cookie
  // timeout: 5000 // 请求超时
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded'
  }
})
// service.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
// 请求拦截
service.interceptors.request.use(
  config => {
    // 发送请求前处理
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // if (store.getters.token) {
    // config.headers['X-Token'] = getToken() 请求头携带token
    // }
    return config
  },
  error => {
    // 请求错误
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  // 请求的全部信息都返回，根据约定好的code码处理
  response => {
    const res = response
    if (res.status !== 200) { // xmlHttpRquest status===200 通信成功
      Message({
        message: res.statusText || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      // 登陆超时
      if ((res.data.error_code && (res.data.error_code === '-1111')) || (res.data.result_cde && (res.data.result_cde === '-1111'))) {
        // logout().then(() => {
        //   router.push('/login')
        // })
      }
      if (res.data.result_cde) {
        res.data.error_code = res.data.result_cde
        res.data.error_msg = res.data.result_msg
      }
      return res.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: '请求数据超时，请稍后重试',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
